import { useState, useEffect, useRef } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { Link } from "react-router-dom";
import ThemeMaker from "../../../components/thememaker";
import axios from "axios";
import { tokenDecode } from "../../../utils/helper";
import { config } from "../../../utils/config";
import '../../../components/table.css';
import styles from "./issues.module.css";
import style from "../../components/Search&Options/Search&Options.module.css";
import CircularProgress from '@mui/material/CircularProgress';
import { Paginated } from "../../../components/Paginated";
import styleii from "../transaction/transaction.module.css";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import { styled } from '@mui/material/styles';
import eye from "../../../icons/eye.png";
import moment from "moment";
import { AgChartsReact } from 'ag-charts-react';
import "../../../index.css";
import { PieChart } from '@mui/x-charts/PieChart';
import { toast } from 'react-toastify';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
const { apiEndpoint, nodeapiEndpoint, baseNodeapiUrl } = config;
// console.log("apiEndpoint", apiEndpoint);
var $ = require('jquery');

const Issues = () => {
    const decoded: any = tokenDecode();
    const [issuesList, setIssuesList] = useState<any[]>([]);
    const [SearchList, setSearchList] = useState<any[]>([]);
    // const [stransactionList, setStransactionList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isExcelLoading, setIsExcelLoading] = useState(false);
    const [isGraphLoading, setIsGraphLoading] = useState(false);
    const [issueDate, setissueDate]: any = useState([])
    const [Fopen, setFOpen] = useState(false);
    const handleFOpen = () => setFOpen(true);
    const handleFClose = () => setFOpen(false);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const { data } = decoded;
    let sellerProviderId = data?.seller_data?.provider_id

    const rawData = {
        seller_id: ''
    }

    const [selectedProvider, setselectedProvider]: any = useState("");
    const [issellerSelected, setissellerselected] = useState(false);
    const { permission: { category, order, product, role, seller, tax, user } } = data;
    const [sellerList, setSellerList] = useState<any[]>([]);
    const current_seller_id = decoded?.data?.user?.seller_id;
    var count = 1;
    // const shipping_address = JSON.parse(_orderDetail?.shipping_address);
    const [nextstep, setnextstep] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [showPages, setShowPages] = useState(false);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        setnextstep(1);
    }, [searchText]);


    useEffect(() => {
        fetchIssuesList();
    }, [nextstep, searchText]);

    const fetchIssuesList = async () => {
        setIsLoading(true);

        try {
            const params: any = {};

            // Normal list mode
            if (!searchText) {
                params.page = nextstep;
            }

            // Search mode
            if (searchText) {
                params.issue_id = searchText;
            }

            const res = await axios.get(
                `${apiEndpoint}/snp/igm/get_issue`,
                {
                    params,
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                    },
                }
            );

            if (res.data && res.data.status && Array.isArray(res.data.data)) {
                setSearchList(res.data.data);
            } else if (res.data && Array.isArray(res.data.data)) {
                setSearchList(res.data.data);
            } else {
                setSearchList([]);
            }

            // pagination handling
            if (!searchText && res.data?.pagination?.totalPages) {
                setTotalPages(res.data.pagination.totalPages);
            } else {
                setTotalPages(1);
            }

        } catch (error) {
            console.log("Error fetching issues:", error);
            setSearchList([]);
        } finally {
            setIsLoading(false);
        }
    };



    const getfilterOption = async (optionvalue: any) => {
        setIsLoading(true);
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/snp/igm/get_issue?status=${optionvalue}`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });
            console.log("data", data);
            const rawList = Array.isArray(data?.data) ? data.data : [];
            const reversedList: any = [...rawList].reverse();
            setIssuesList(reversedList);

            const isRootSeller = (current_seller_id == 1 || current_seller_id == "1") &&
                (decoded?.data?.user?.parent_id == 0 || decoded?.data?.user?.parent_id == "0");

            if (isRootSeller || !sellerProviderId) {
                setSearchList(reversedList);
            } else {
                const filtered = reversedList.filter((item: any) => {
                    let provId = item?.order_details?.provider_id;
                    if (!provId && typeof item?.order_details === "string") {
                        try {
                            provId = JSON.parse(item.order_details)?.provider_id;
                        } catch (e) { }
                    }
                    return provId === sellerProviderId;
                });
                setSearchList(filtered);
            }
        } catch (error) {
            console.log("error", error);
            setSearchList([]);
        } finally {
            setIsLoading(false);
        }
    };






    const COLUMNS = [
        {
            Header: "Serial No.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "Ticket ID",
            accessor: (item: any) => (item?.issue_id),
            sticky: "left"
        },
        {
            Header: "Issues Type",
            accessor: (item: any) => (item?.issue_type),
            sticky: "left"
        },
        {
            Header: "Category",
            accessor: (item: any) => (item?.category),
            sticky: "left"
        },
        {
            Header: "Sub Category",
            accessor: (item: any) => (item?.sub_category),
            sticky: "left"
        },
        {
            Header: "Status",
            sticky: "left",
            accessor: (item: any) => (item?.status === "Closed" || item?.status === "CLOSED" ? (
                <span className="badge badge-success">Closed</span>
            ) : item?.status === "RESOLVED" ? (
                <span className="badge badge-success">Resolved</span>
            ) : item?.status === "ESCALATE" ? (
                <span className="badge badge-danger">Escalated</span>
            )
                : item?.status === "NEED-MORE-INFO" ? (
                    <span className="badge badge-warning">Need More Info</span>
                )
                    : (
                        <span className="badge badge-warning">Processing</span>
                    )
            ),
        },
        {
            Header: "Action",
            filterable: true,
            sticky: "left",
            Cell: ({ row }: any) => (<Link to={{ pathname: '/onissues', state: { tkt: row?.original.issue_id } }} className="badge badge-primary">View</Link>),
        },
    ];

    const getSellerList = async () => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getsellerlist`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });
            if (data.status === 200) {
                // console.log(data.data)
                setSellerList(data.data);
            }
        } catch (error) {
            console.log("error", error);
        }
    }
    const inputHandler = async (e: any) => {
        var optionvalue = e.target.value;
        if (optionvalue === "") {
            fetchIssuesList();
        } else {
            let data = [...issuesList]
            setSearchList(data.filter((item: any) => item.order_details.provider_id == optionvalue));
            getcounts(optionvalue);
            setissellerselected(true)
        }
    };

    const handlerFilterOption = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const optionValue = e.target.value;
        optionValue === "" || optionValue === null ? fetchIssuesList() : getfilterOption(optionValue);
    };


    useEffect(() => {
        fetchIssuesList();
        getSellerList();
        getgraphData();
        if (current_seller_id == 1) {
            getcounts("");
        } else {
            getcounts(sellerProviderId);
        }


    }, []);

    const [counts, setcounts] = useState({
        Closed_Tickets: 0,
        Processing_Tickets: 0,
        Resolved_Tickets: 0,
        Total_tickets: 0,
        Seller_Closed_Tickets: 0,
        Seller_Processing_Tickets: 0,
        Seller_Resolved_Tickets: 0,
        Seller_Total_Tickets: 0
    })

    const [series, setSeries] = useState([
        {
            name: 'Open Tickets',
            data: [50, 11, 10, 40]
        },
        {
            name: 'Closed Tickets',
            data: [11, 30, 40, 76]
        }
    ]);
    const [pieChartData, setpieChartData] = useState({
        "resolved": 0,
        "open": 0,
        "closed": 0,
        // "processing": 0
    })
    const [options, setOptions] = useState<any>({
        data: [
            { label: 'Resolved', value: pieChartData.resolved },
            { label: 'Open', value: pieChartData.open },
            { label: 'Closed', value: pieChartData.closed },
            // { asset: 'Processing', amount: pieChartData.processing },

        ],
        width: 300,
        series: [
            {
                type: "pie",
                angleKey: "amount",
                calloutLabelKey: "asset",
                sectorLabelKey: "amount",
                sectorLabel: {
                    color: "white",
                    fontWeight: "bold",
                    formatter: ({ value }: any) => `${(value)}`,
                },
            },
        ],

    });

    async function getcounts(sellerProviderId: string) {

        try {
            const { data } = await axios({
                url: `${apiEndpoint}/snp/igm/get_tickets_count`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
                },
                // data: { provider_id: sellerProviderId }

            });

            const countData = data?.data || {};
            setcounts({
                Total_tickets: countData.Total_tickets ?? countData.Seller_Total_Tickets ?? 0,
                Resolved_Tickets: countData.Resolved_Tickets ?? countData.Seller_Resolved_Tickets ?? 0,
                Closed_Tickets: countData.Closed_Tickets ?? countData.Seller_Closed_Tickets ?? 0,
                Processing_Tickets: countData.Processing_Tickets ?? countData.Seller_Processing_Tickets ?? 0,
                Seller_Closed_Tickets: countData.Seller_Closed_Tickets ?? countData.Closed_Tickets ?? 0,
                Seller_Processing_Tickets: countData.Seller_Processing_Tickets ?? countData.Processing_Tickets ?? 0,
                Seller_Resolved_Tickets: countData.Seller_Resolved_Tickets ?? countData.Resolved_Tickets ?? 0,
                Seller_Total_Tickets: countData.Seller_Total_Tickets ?? countData.Total_tickets ?? 0
            });
            setpieChartData(countData);
            setOptions((prev: any) => {
                return {
                    ...prev,
                    data: [
                        { label: 'Resolved', value: countData.Resolved_Tickets ?? countData.Seller_Resolved_Tickets ?? 0 },
                        { label: 'Processing', value: countData.Processing_Tickets ?? countData.Seller_Processing_Tickets ?? 0 },
                        { label: 'Closed', value: countData.Closed_Tickets ?? countData.Seller_Closed_Tickets ?? 0 },
                    ]
                }
            });
        } catch (error) {
            console.log("error", error);
        }


    }

    console.log("options--------->", options)

    async function getgraphData() {
        let providerID;
        if (current_seller_id == 1) {
            providerID = ""
        } else {
            providerID = sellerProviderId
        }
        try {
            setIsGraphLoading(true)
            const { data } = await axios({
                url: `${baseNodeapiUrl}/igm/get_ticketsby_date`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
                },
                data: {
                    provider_id: providerID
                }
            });
            console.log(data, "IGM 213");


            if (data?.data?.length >= 0) {
                let x = data?.data?.map((item: any) => item?.date);
                let openIssueCountArray = data?.data?.map((item: any) => item?.processingCount);
                let closedIssueCountArray = data?.data?.map((item: any) => item?.resolvedCount);

                let g = [...series];
                g[0] = { ...g[0], data: openIssueCountArray };
                g[1] = { ...g[1], data: closedIssueCountArray };

                if (x && x.length > 0) {
                    setissueDate(x);
                    setOptions((prev: any) => {
                        return { ...prev, xaxis: { ...prev.xaxis, categories: x } }
                    })

                    setSeries((prev: any) => {
                        return g
                    })
                }
            }

            setIsGraphLoading(false)
        } catch (error) {
            console.log("error", error);
            setIsGraphLoading(false)
        }


    }

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },

    }));




    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#e2e2e2",
            color: "black",
            fontSize: 12,
            fontWeight: 600,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 11,
            fontWeight: 600,

        },
    }));

    function calculateAge(creationDateString: any, closedDateString: any) {
        var currentDate: any = new Date(); // Current date and time

        // Convert creation and closed dates to Date objects
        var creationDate: any = new Date(creationDateString);
        var closedDate: any = closedDateString ? new Date(closedDateString) : null;

        // Calculate age based on whether the item is closed or not
        var age;
        if (closedDate) {
            age = closedDate - creationDate; // Duration between creation and closure
        } else {
            age = currentDate - creationDate; // Duration between creation and current date
        }

        // Convert age from milliseconds to days (or hours, minutes, etc. as needed)
        age = age / (1000 * 60 * 60 * 24); // Convert milliseconds to days

        return age;
    }



    const palette = ['#459d55', 'rebeccapurple', 'orange', '#3498db'];



    console.log("series------>", series);

    const exportIGMTickets = async () => {
        try {
            setIsExcelLoading(true);
            const response = await axios({
                url: `${baseNodeapiUrl}/igm/export_igm`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
                },
                data: {},
                responseType: "blob",
            });
            const { data } = response;
            const contentType = response.headers["content-type"];
            if (contentType.includes("application/json")) {
                if (response.data?.data.length === 0) {
                    toast.success("No processing issues found. No data to export.");
                    return;
                }
            }
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "Tickets.xlsx";
            link.click();
            URL.revokeObjectURL(link.href);
            toast.success("Tickets exported successfully!");
        }
        catch (error) {
            console.log("Error in Export IGM Tickets ::", error);
        }
        finally {
            setIsExcelLoading(false);
        }
    };

    const fileChangeHandler = async (event: any) => {
        const file = event.target.files[0];
        if (!file) {
            toast.warning("Please select a file to import.");
            return;
        }
        const allowedTypes = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'text/csv',
            'application/octet-stream'
        ];

        if (!allowedTypes.includes(file.type) && !file.name.toLowerCase().endsWith('.xlsx') && !file.name.toLowerCase().endsWith('.xls') && !file.name.toLowerCase().endsWith('.csv')) {
            toast.error("Please select a valid Excel (.xlsx, .xls) or CSV (.csv) file.");
            event.target.value = '';
            return;
        }
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
            toast.error("File size must be less than 10MB.");
            event.target.value = '';
            return;
        }
        setSelectedFile(file);
    };

    const importTicketsFile = async () => {
        if (!selectedFile) {
            toast.error("No file selected. Please select a file first.");
            return;
        }
        try {
            const formData = new FormData();
            formData.append('file', selectedFile);

            const response = await axios.post(
                `${baseNodeapiUrl}/igm/import_igm`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        // Add any additional headers like authorization if needed
                        // 'Authorization': `Bearer ${yourToken}`
                    },
                }
            );

            console.log("Import successful:", response.data);
            toast.success("File imported successfully!");
            setSelectedFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } catch (error: any) {
            console.error("Error importing tickets:", error);
            toast.error(
                error.response?.data?.message || "Failed to import file. Please try again."
            );
        }
    };

    const [showExport, setShowExport] = useState(false);

    const exportHandler = () => {
        setShowExport(true)
    }

    const [dateFilter, setDateFilter] = useState({
        startDate: "",
        endDate: ""
    })

    const dateChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setDateFilter(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const ExportHandler = async () => {
        if (!dateFilter.startDate || !dateFilter.endDate) {
            toast.error("Please select start date and end date");
            return;
        }

        try {
            const { startDate, endDate } = dateFilter;

            const response = await axios.get(
                `${apiEndpoint}/snp/igm/export_filter_igm`,
                {
                    params: { startDate, endDate },
                    responseType: "blob",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const blob = new Blob([response.data], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `Export_${startDate}_to_${endDate}.xlsx`;
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);

            setShowExport(false);
            setDateFilter({ startDate: "", endDate: "" });
            toast.success("Successfully Exported");
        } catch (error) {
            console.log("Export error", error);
            toast.error("Export failed");
        }
    };






    return (
        <>
            <ThemeMaker>
                <div style={{ background: "#f4f6fa", height: "85vh", padding: "20px 24px", overflow: "scroll" }}>

                    {/* ── Page Title ── */}
                    <div style={{ marginBottom: "16px" }}>
                        <h4 style={{ color: "#1a1a2e", fontWeight: 700, fontSize: "22px", margin: 0 }}>IGM Portal</h4>
                    </div>

                    {/* ── Two-column layout ── */}
                    <div style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}>

                        {/* ── LEFT: Ticket List Card ── */}
                        <div style={{ flex: 1, minWidth: 0, background: "#fff", borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", overflow: "hidden" }}>

                            {/* Card Header */}
                            <div style={{ padding: "14px 20px", borderBottom: "1px solid #f0f0f0", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "10px" }}>
                                <h6 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a1a2e" }}>Ticket List</h6>
                                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                    {/* Export All Data (date range) */}
                                    <button
                                        onClick={exportHandler}
                                        style={{ background: "#F97316", color: "#fff", border: "none", borderRadius: "6px", padding: "7px 16px", fontWeight: 600, fontSize: "13px", cursor: "pointer", transition: "opacity 0.2s" }}
                                        onMouseEnter={e => (e.currentTarget.style.opacity = "0.85")}
                                        onMouseLeave={e => (e.currentTarget.style.opacity = "1")}
                                    >
                                        All Export
                                    </button>
                                    {/* Import */}
                                    {/* <button
                                        onClick={handleFOpen}
                                        style={{ background: "#F97316", color: "#fff", border: "none", borderRadius: "6px", padding: "7px 16px", fontWeight: 600, fontSize: "13px", cursor: "pointer", transition: "opacity 0.2s" }}
                                        onMouseEnter={e => (e.currentTarget.style.opacity = "0.85")}
                                        onMouseLeave={e => (e.currentTarget.style.opacity = "1")}
                                    >
                                        Import
                                    </button> */}
                                    {/* Export Tickets (all, no date filter) */}
                                    {/* <button
                                        onClick={exportIGMTickets}
                                        disabled={isExcelLoading}
                                        style={{ background: "#F97316", color: "#fff", border: "none", borderRadius: "6px", padding: "7px 16px", fontWeight: 600, fontSize: "13px", cursor: isExcelLoading ? "not-allowed" : "pointer", opacity: isExcelLoading ? 0.7 : 1, transition: "opacity 0.2s" }}
                                        onMouseEnter={e => { if (!isExcelLoading) e.currentTarget.style.opacity = "0.85"; }}
                                        onMouseLeave={e => { if (!isExcelLoading) e.currentTarget.style.opacity = "1"; }}
                                    >
                                        {isExcelLoading ? "Exporting..." : "Export Tickets"}
                                    </button> */}
                                </div>
                            </div>

                            {/* Export Modal */}
                            {showExport && (
                                <Modal open={showExport} onClose={() => setShowExport(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                                    <div className="modal-dialog modal-dialog-centered" role="document">
                                        <div className="modal-content" style={{ minHeight: "200px" }}>
                                            <div className="modal-header d-flex justify-content-between">
                                                <h5 className="modal-title text-dark genericlabel">Export All Data</h5>
                                                <span aria-hidden="true" onClick={() => setShowExport(false)} style={{ cursor: "pointer" }}><CloseIcon /></span>
                                            </div>
                                            <div className="modal-body">
                                                <div className="mb-3">
                                                    <label>Start Date</label>
                                                    <input type="date" name="startDate" className="form-control" onChange={dateChangeHandler} />
                                                </div>
                                                <div className="mb-3">
                                                    <label>End Date</label>
                                                    <input type="date" name="endDate" className="form-control" onChange={dateChangeHandler} />
                                                </div>
                                            </div>
                                            <div className="modal-footer d-flex justify-content-end" style={{ gap: "20px" }}>
                                                <button style={{ background: "#F97316", color: "#fff", border: "none", borderRadius: "6px", padding: "7px 20px", fontWeight: 600, cursor: "pointer" }} onClick={ExportHandler}>Export</button>
                                            </div>
                                        </div>
                                    </div>
                                </Modal>
                            )}

                            {/* Filters Row */}
                            <div style={{ padding: "12px 20px", borderBottom: "1px solid #f0f0f0", display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
                                <select
                                    style={{ flex: "1 1 150px", height: "38px", borderRadius: "6px", border: "1px solid #dee2e6", padding: "0 10px", fontSize: "13px", color: "#495057", outline: "none", background: "#f8f9fa", cursor: "pointer" }}
                                    onChange={(e: any) => handlerFilterOption(e)}
                                >
                                    <option value="" disabled selected>Filter By Status</option>
                                    <option value="">All Tickets</option>
                                    <option value="PROCESSING">Processing</option>
                                    <option value="RESOLVED">Resolved</option>
                                    <option value="CLOSED">Closed</option>
                                </select>

                                {current_seller_id == 1 ? (
                                    <select
                                        style={{ flex: "1 1 170px", height: "38px", borderRadius: "6px", border: "1px solid #dee2e6", padding: "0 10px", fontSize: "13px", color: "#495057", outline: "none", background: "#f8f9fa", cursor: "pointer" }}
                                        onChange={(e: any) => inputHandler(e)}
                                    >
                                        <option value="" disabled selected>Select Seller</option>
                                        {sellerList.map((item: any) => (
                                            <option value={item.provider_id}>{item?.company_name}</option>
                                        ))}
                                    </select>
                                ) : null}

                                <input
                                    type="search"
                                    style={{ flex: "1 1 220px", height: "38px", borderRadius: "6px", border: "1px solid #dee2e6", padding: "0 12px", fontSize: "13px", color: "#495057", outline: "none", background: "#f8f9fa" }}
                                    placeholder="Search by Ticket ID..."
                                    onChange={(e) => setSearchText(e.target.value)}
                                />
                            </div>

                            {/* Table */}
                            <div style={{ overflowX: "auto", maxHeight: "calc(100vh - 280px)", height: "420px", overflowY: "auto", scrollbarWidth: "thin" }}>
                                {!isLoading ? (
                                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                                        <thead style={{ position: "sticky", top: 0, zIndex: 10 }}>
                                            <tr>
                                                {["Serial No.", "Ticket ID", "Order ID", "Status", "Issue Created Date", "Ageing", "Category", "Sub Category", "Closed Date", "Action"].map((h) => (
                                                    <th key={h} style={{ padding: "11px 14px", textAlign: "left", fontWeight: 600, color: "#fff", fontSize: "13px", background: "#F97316", whiteSpace: "nowrap", borderRight: "1px solid rgba(255,255,255,0.15)" }}>{h}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {SearchList.length > 0 ? SearchList.map((row: any, index: number) => {
                                                const creationDate = row?.created_at;
                                                const closedDate = row?.closed_time;
                                                const age = calculateAge(creationDate, closedDate);
                                                return (
                                                    <tr key={row.issue_id}
                                                        style={{ borderBottom: "1px solid #f0f0f0", background: index % 2 === 0 ? "#fff" : "#fafafa", transition: "background .15s" }}
                                                        onMouseEnter={e => (e.currentTarget.style.background = "#fff3e0")}
                                                        onMouseLeave={e => (e.currentTarget.style.background = index % 2 === 0 ? "#fff" : "#fafafa")}
                                                    >
                                                        <td style={{ padding: "10px 14px", color: "#495057", fontWeight: 500 }}>{(nextstep - 1) * 10 + index + 1}</td>
                                                        <td style={{ padding: "10px 14px", color: "#1a1a2e", fontWeight: 700 }}>{row.issue_id}</td>
                                                        <td style={{ padding: "10px 14px", color: "#495057" }}>{row?.order_id}</td>
                                                        <td style={{ padding: "10px 14px" }}>
                                                            {row.status === "RESOLVED" || row.status === "CLOSED" ? (
                                                                <span style={{ padding: "3px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 700, background: "#d1fae5", color: "#15803d", border: "1px solid #bbf7d0" }}>{row.status}</span>
                                                            ) : row.status === "PROCESSING" ? (
                                                                <span style={{ padding: "3px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 700, background: "#fef3c7", color: "#b45309", border: "1px solid #fde68a" }}>{row.status}</span>
                                                            ) : row.status === "OPEN" ? (
                                                                <span style={{ padding: "3px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 700, background: "#dbeafe", color: "#1d4ed8", border: "1px solid #bfdbfe" }}>{row.status}</span>
                                                            ) : (
                                                                <span style={{ padding: "3px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 700, background: "#f3f4f6", color: "#6b7280", border: "1px solid #e5e7eb" }}>{row.status || "-"}</span>
                                                            )}
                                                        </td>
                                                        <td style={{ padding: "10px 14px", color: "#495057", whiteSpace: "nowrap" }}>{row.created_at ? moment(row.created_at).format("DD MMM YYYY, hh:mm A") : "-"}</td>
                                                        <td style={{ padding: "10px 14px", color: "#495057", textAlign: "center" }}>{Math.ceil(age)} d</td>
                                                        <td style={{ padding: "10px 14px", color: "#495057" }}>{row.category || "-"}</td>
                                                        <td style={{ padding: "10px 14px", color: "#495057" }}>{row.sub_category || "-"}</td>
                                                        <td style={{ padding: "10px 14px", color: "#495057", whiteSpace: "nowrap" }}>{row.closed_time ? moment(row.closed_time).format("DD MMM YYYY, hh:mm A") : "-"}</td>
                                                        <td style={{ padding: "10px 14px" }}>
                                                            <Link to={{ pathname: '/onissues', state: { tkt: row?.issue_id } }}>
                                                                <button style={{ background: "#F97316", color: "#fff", border: "none", borderRadius: "6px", padding: "5px 14px", fontWeight: 600, fontSize: "12px", cursor: "pointer", whiteSpace: "nowrap" }}>
                                                                    View Details
                                                                </button>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                );
                                            }) : (
                                                <tr>
                                                    <td colSpan={10} style={{ padding: "60px 16px", textAlign: "center", color: "#adb5bd" }}>
                                                        <p style={{ margin: 0, fontSize: "15px", fontWeight: 700, color: "#6c757d" }}>No tickets found</p>
                                                        <p style={{ margin: "5px 0 0", fontSize: "12px", color: "#adb5bd" }}>Try adjusting your search or filter criteria</p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                ) : (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                                        <CircularProgress style={{ color: "#F97316" }} />
                                    </div>
                                )}
                            </div>

                            {/* Pagination */}
                            <div style={{ padding: "12px 20px", borderTop: "1px solid #f0f0f0", display: "flex", justifyContent: "center" }}>
                                <ul className="pagination" style={{ margin: 0 }}>
                                    <li className={`page-item ${nextstep === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => { setnextstep(1); setShowPages(true); }} disabled={nextstep === 1}>First</button>
                                    </li>
                                    <li className={`page-item ${nextstep === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => { setnextstep(prev => Math.max(prev - 1, 1)); setShowPages(true); }} disabled={nextstep === 1}>Prev</button>
                                    </li>
                                    {totalPages > 1 && (() => {
                                        const pages = [];
                                        const current = nextstep;
                                        if (current > 3) {
                                            pages.push(<li key="first" className="page-item"><button className="page-link" onClick={() => setnextstep(1)}>1</button></li>);
                                            if (current > 4) pages.push(<li key="e1" className="page-item disabled"><span className="page-link">...</span></li>);
                                        }
                                        const startPage = Math.max(1, current - 2);
                                        const endPage = Math.min(totalPages, current + 2);
                                        for (let i = startPage; i <= endPage; i++) {
                                            pages.push(<li key={i} className={`page-item ${nextstep === i ? 'active' : ''}`}><button className="page-link" onClick={() => setnextstep(i)}>{i}</button></li>);
                                        }
                                        if (current < totalPages - 2) {
                                            if (current < totalPages - 3) pages.push(<li key="e2" className="page-item disabled"><span className="page-link">...</span></li>);
                                            pages.push(<li key="last" className={`page-item ${nextstep === totalPages ? 'active' : ''}`}><button className="page-link" onClick={() => setnextstep(totalPages)}>{totalPages}</button></li>);
                                        }
                                        return pages;
                                    })()}
                                    <li className={`page-item ${nextstep === totalPages ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => { setnextstep(prev => Math.min(prev + 1, totalPages)); setShowPages(true); }} disabled={nextstep === totalPages}>Next</button>
                                    </li>
                                    <li className={`page-item ${nextstep === totalPages ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => { setnextstep(totalPages); setShowPages(true); }} disabled={nextstep === totalPages}>Last</button>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* ── RIGHT: KPI Cards + Pie Chart ── */}
                        <div style={{ width: "260px", flexShrink: 0, display: "flex", flexDirection: "column", gap: "14px", position: "sticky", top: "20px" }}>

                            {/* 2×2 KPI grid */}
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                                <div
                                    style={{ background: "#fff", borderRadius: "12px", border: "1px solid #E5E7EB", padding: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.06)", display: "flex", flexDirection: "column", gap: "6px", cursor: "default", transition: "box-shadow 200ms ease, transform 200ms ease" }}
                                    onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.10)"; e.currentTarget.style.transform = "translateY(-3px)"; }}
                                    onMouseLeave={e => { e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.06)"; e.currentTarget.style.transform = "translateY(0)"; }}
                                >
                                    <div style={{ width: "36px", height: "36px", borderRadius: "10px", background: "#FFF7ED", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <AssignmentTurnedInIcon style={{ color: "#F97316", fontSize: "20px" }} />
                                    </div>
                                    <p style={{ fontSize: "26px", fontWeight: 700, color: "#111827", margin: 0, lineHeight: 1 }}>
                                        {(current_seller_id == 1 && !issellerSelected) ? counts?.Total_tickets : counts.Seller_Total_Tickets}
                                    </p>
                                    <p style={{ fontSize: "11px", fontWeight: 600, color: "#6B7280", margin: 0, textTransform: "uppercase", letterSpacing: "0.5px" }}>Total Tickets</p>
                                </div>

                                {/* Open Tickets */}
                                <div
                                    style={{ background: "#fff", borderRadius: "12px", border: "1px solid #E5E7EB", padding: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.06)", display: "flex", flexDirection: "column", gap: "6px", cursor: "default", transition: "box-shadow 200ms ease, transform 200ms ease" }}
                                    onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.10)"; e.currentTarget.style.transform = "translateY(-3px)"; }}
                                    onMouseLeave={e => { e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.06)"; e.currentTarget.style.transform = "translateY(0)"; }}
                                >
                                    <div style={{ width: "36px", height: "36px", borderRadius: "10px", background: "#FFFBEB", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <PublishedWithChangesIcon style={{ color: "#F59E0B", fontSize: "20px" }} />
                                    </div>
                                    <p style={{ fontSize: "26px", fontWeight: 700, color: "#111827", margin: 0, lineHeight: 1 }}>
                                        {(current_seller_id == 1 && !issellerSelected) ? counts.Processing_Tickets : counts?.Seller_Processing_Tickets}
                                    </p>
                                    <p style={{ fontSize: "11px", fontWeight: 600, color: "#6B7280", margin: 0, textTransform: "uppercase", letterSpacing: "0.5px" }}>Open Tickets</p>
                                </div>

                                {/* Closed Tickets */}
                                <div
                                    style={{ background: "#fff", borderRadius: "12px", border: "1px solid #E5E7EB", padding: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.06)", display: "flex", flexDirection: "column", gap: "6px", cursor: "default", transition: "box-shadow 200ms ease, transform 200ms ease" }}
                                    onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.10)"; e.currentTarget.style.transform = "translateY(-3px)"; }}
                                    onMouseLeave={e => { e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.06)"; e.currentTarget.style.transform = "translateY(0)"; }}
                                >
                                    <div style={{ width: "36px", height: "36px", borderRadius: "10px", background: "#F0FDF4", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <CheckCircleIcon style={{ color: "#22C55E", fontSize: "20px" }} />
                                    </div>
                                    <p style={{ fontSize: "26px", fontWeight: 700, color: "#111827", margin: 0, lineHeight: 1 }}>
                                        {(current_seller_id == 1 && !issellerSelected) ? counts?.Closed_Tickets : counts?.Seller_Closed_Tickets}
                                    </p>
                                    <p style={{ fontSize: "11px", fontWeight: 600, color: "#6B7280", margin: 0, textTransform: "uppercase", letterSpacing: "0.5px" }}>Closed Tickets</p>
                                </div>

                                {/* Resolved Tickets */}
                                <div
                                    style={{ background: "#fff", borderRadius: "12px", border: "1px solid #E5E7EB", padding: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.06)", display: "flex", flexDirection: "column", gap: "6px", cursor: "default", transition: "box-shadow 200ms ease, transform 200ms ease" }}
                                    onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.10)"; e.currentTarget.style.transform = "translateY(-3px)"; }}
                                    onMouseLeave={e => { e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.06)"; e.currentTarget.style.transform = "translateY(0)"; }}
                                >
                                    <div style={{ width: "36px", height: "36px", borderRadius: "10px", background: "#ECFDF5", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <HowToRegIcon style={{ color: "#059669", fontSize: "20px" }} />
                                    </div>
                                    <p style={{ fontSize: "26px", fontWeight: 700, color: "#111827", margin: 0, lineHeight: 1 }}>
                                        {(current_seller_id == 1 && !issellerSelected) ? counts?.Resolved_Tickets : counts?.Seller_Resolved_Tickets}
                                    </p>
                                    <p style={{ fontSize: "11px", fontWeight: 600, color: "#6B7280", margin: 0, textTransform: "uppercase", letterSpacing: "0.5px" }}>Resolved Tickets</p>
                                </div>
                            </div>

                            {/* Pie Chart */}
                            {options?.data.some((item: any) => item.amount !== 0) && (
                                <div style={{ background: "#fff", borderRadius: "12px", border: "1px solid #E5E7EB", padding: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                                    <p style={{ fontSize: "13px", fontWeight: 700, color: "#1a1a2e", margin: "0 0 10px" }}>Ticket Distribution</p>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <PieChart
                                            colors={palette}
                                            series={[{ data: options?.data, innerRadius: 35, outerRadius: 70 }]}
                                            width={228}
                                            height={160}
                                            slotProps={{ legend: { hidden: true } }}
                                        />
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "8px", flexWrap: "wrap" }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}><div style={{ width: "10px", height: "10px", borderRadius: "2px", background: "rgb(69,157,85)" }}></div><span style={{ fontSize: "11px", color: "#6c757d" }}>Resolved</span></div>
                                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}><div style={{ width: "10px", height: "10px", borderRadius: "2px", background: "orange" }}></div><span style={{ fontSize: "11px", color: "#6c757d" }}>Closed</span></div>
                                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}><div style={{ width: "10px", height: "10px", borderRadius: "2px", background: "#663399" }}></div><span style={{ fontSize: "11px", color: "#6c757d" }}>Open</span></div>
                                    </div>
                                </div>
                            )}
                        </div>
                        {/* ── END RIGHT ── */}

                    </div>
                    {/* ── END two-column layout ── */}

                </div>

                {/* Import Tickets Modal */}
                <Modal open={Fopen} onClose={handleFClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" style={{ minHeight: "200px" }}>
                            <div className="modal-header d-flex justify-content-between">
                                <h5 className="modal-title text-dark genericlabel" id="exampleModalLongTitle">Import Tickets</h5>
                                <span aria-hidden="true" onClick={handleFClose} style={{ cursor: "pointer" }}><CloseIcon /></span>
                            </div>
                            <div className="modal-body w-75">
                                <div className="d-flex">
                                    <div>
                                        <label>Select File</label>
                                        <input name="importTickets" type="file" className="form-control px-1" style={{ cursor: "pointer", paddingTop: '3px' }} ref={fileInputRef} onChange={fileChangeHandler} />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-header d-flex justify-content-end" style={{ gap: "20px" }}>
                                <button className="btn btn-danger" onClick={handleFClose}>Close</button>
                                <button style={{ background: "#F97316", color: "#fff", border: "none", borderRadius: "6px", padding: "7px 18px", fontWeight: 600, cursor: "pointer" }} onClick={importTicketsFile}>Import</button>
                            </div>
                        </div>
                    </div>
                </Modal>

            </ThemeMaker>
        </>
    )
}

export default Issues;
